import { createSelector } from '@reduxjs/toolkit';
import { IGlobalReduxStore } from 'store';

const getUserPermissions = (state: IGlobalReduxStore) => state.auth.permissions;

export const isPayrollFeatureEnabledSelector = createSelector(getUserPermissions, (permissions) => {
  if (permissions?.PAYROLL?.access) return permissions.PAYROLL.access.includes('read');
  else return false;
});
